export default "__VITE_ASSET__c6d99c2d__"